import Image from "next/image";
import { IoDownloadOutline, IoEyeOutline } from "react-icons/io5";
import { ClassificationTypes } from "@/utils/enum";

import { correctUrlString, formatDateRange } from "@/utils/utils";
import { useEffect, useState } from "react";

const EventCard = ({ item }: any) => {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const handleDownloadClick = async () => {
    if (imageUrl) {
      try {
        const response = await fetch(imageUrl);
        if (!response.ok) throw new Error("Network response was not ok.");
        const blob = await response.blob();
        const filename = imageUrl.split("/").pop() || "image.jpg";
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Error downloading image:", error);
      }
    } else {
      console.error("No image URL found.");
    }
  };
  const handleViewClick = () => {
    if (imageUrl) {
      window.open(imageUrl, "_blank");
    }
  };
  useEffect(() => {
    async function fetchImageUrl() {
      try {
        const repo = await fetch(
          `${process.env.NEXT_PUBLIC_API_BASE_URL}/api/schedule/${item.id}`,
        );
        const response: any = await repo.json();
        if (response.url) {
          setImageUrl(response.url);
        }
      } catch (error) {
        console.log("Error fetching image:", error);
      }
    }
    fetchImageUrl();
  }, [item.id]);

  return (
    <div
      className="rounded"
      style={{
        backgroundColor: "#fff",
        marginBottom: "1.2rem",
        padding: "1rem",
      }}
    >
      <div className="w-full">
        {/* details section */}
        <div
          className="rounded px-3 py-2 w-full"
          style={{ backgroundColor: "#E8E8F9" }}
        >
          <h6 className="fs-6 fw-bold mb-1">
            {item?.attributes?.fees_sub_category?.data?.attributes?.name}
          </h6>
          {/* other details */}
          <div className="d-flex flex-wrap align-items-center text-muted">
            <p
              style={{ fontSize: "0.8rem", lineHeight: "0" }}
              className="mb-0 me-1 text-secondary"
            >
              {item?.attributes?.venue_name}
            </p>
            <span className="mx-1">|</span>
            <p
              style={{ fontSize: "0.8rem", lineHeight: "0" }}
              className="mb-0 me-1 text-secondary"
            >
              {" "}
              {item?.attributes?.fees_category?.data?.attributes?.name} :{" "}
              {item?.attributes?.fees_category?.data?.attributes?.name ==
              ClassificationTypes.Group
                ? `${item?.attributes?.minimum_entry} - ${item?.attributes?.maximum_entry}`
                : item?.attributes?.maximum_entry}
            </p>
            <span className="mx-1">|</span>
            <p
              style={{ fontSize: "0.8rem", lineHeight: "0" }}
              className="mb-0 me-1 text-secondary"
            >
              Gender: {item?.attributes?.gender}
            </p>
            <span className="mx-1">|</span>
            <p
              style={{ fontSize: "0.8rem", lineHeight: "0" }}
              className="mb-0 me-1 text-secondary"
            >
              Age: {item?.attributes?.age_from || " "} to{" "}
              {item?.attributes?.age_to || " "}
            </p>
            <span className="mx-1">|</span>
            <p
              style={{ fontSize: "0.8rem", lineHeight: "0" }}
              className="mb-0 text-secondary"
            >
              Event dates:{" "}
              {formatDateRange(
                item?.attributes?.event_start_date || "2024-10-10",
                item?.attributes?.event_end_date || null,
              )}
            </p>
          </div>
        </div>
        {/* image section */}
        <div className="mt-2 position-relative w-100">
          {imageUrl ? (
            <>
              <Image
                src={
                  imageUrl || correctUrlString(item?.attributes?.image_link)[0]
                }
                height={300}
                width={500}
                style={{
                  maxHeight: "306px",
                  minHeight: "185px",
                  objectFit: "cover", // Ensures the image covers the container without stretching
                  width: "100%", // Makes sure the image container takes the full width
                  display: "block", // Removes any extra space below the image
                }}
                className="w-100 rounded"
                alt="..."
              />
              {/* Bigger Button on the Right Top */}
              <button
                className="btn position-absolute top-0 end-0 m-2"
                style={{
                  background: "transparent", // Remove default blue background
                  border: "none", // Remove default border
                  padding: "0", // Remove default padding
                  boxShadow: "none", // Remove any default shadow
                  display: "inline-flex", // Adjust size to content
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative", // Ensure the button is positioned correctly
                  overflow: "visible", // Ensure the button content is not clipped
                }}
              >
                {item?.attributes?.fees_sub_type?.data?.attributes?.name ===
                  "Competition" && (
                  <div
                    style={{
                      padding: "11px 16px",
                      gap: "10px",
                      display: "flex",
                      maxHeight: "32px",
                      borderRadius: "34px",
                      border: "1px solid #212121",
                      color: "#310000",
                      background: "#FFF",
                      whiteSpace: "nowrap", // Prevent text wrapping
                      alignItems: "center",
                    }}
                  >
                    {"Competition"}
                  </div>
                )}
                {item?.attributes?.fees_sub_type?.data?.attributes?.name ===
                  "Workshop" && (
                  <div
                    style={{
                      padding: "11px 16px",
                      gap: "10px",
                      display: "flex",
                      maxHeight: "32px",
                      borderRadius: "34px",
                      border: "1px solid #212121",
                      color: "#310000",
                      background:
                        "linear-gradient(0deg, rgba(33, 33, 33, 0.12) 0%, rgba(33, 33, 33, 0.12) 100%), #FFF",
                      whiteSpace: "nowrap", // Prevent text wrapping
                      alignItems: "center",
                    }}
                  >
                    {"Workshop"}
                  </div>
                )}
                {item?.attributes?.fees_sub_type?.data?.attributes?.name ===
                  "Premier Competition" && (
                  <div
                    style={{
                      padding: "11px 16px",
                      gap: "10px",
                      display: "flex",
                      maxHeight: "32px",
                      borderRadius: "34px",
                      border: "1px solid #3F41D1",
                      color: "#3F41D1",
                      background:
                        "linear-gradient(0deg, rgba(63, 65, 209, 0.12) 0%, rgba(63, 65, 209, 0.12) 100%), #FFF",
                      whiteSpace: "nowrap", // Prevent text wrapping
                      alignItems: "center",
                    }}
                  >
                    {"Premier Event"}
                  </div>
                )}
                {!["Competition", "Workshop", "Premier Competition"].includes(
                  item?.attributes?.fees_sub_type?.data?.attributes?.name,
                ) && (
                  <div
                    style={{
                      marginTop: "2px",
                      position: "absolute",
                      zIndex: 1,
                      padding: "11px 16px",
                      gap: "10px",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      display: "flex",
                      maxHeight: "32px",
                      marginRight: "3px",
                      right: 0,
                      borderRadius: "34px",
                      border: "1px solid #212121",
                      color: "#310000",
                      background: "#FFF",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      maxWidth: "60%",
                      fontSize: "0.75rem",
                      textOverflow: "ellipsis",
                      top: "4px",
                    }}
                    title={
                      item?.attributes?.fees_sub_type?.data.attributes?.name
                    }
                  >
                    <span
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                      }}
                    >
                      {item?.attributes?.fees_sub_type?.data?.attributes?.name}
                    </span>
                  </div>
                )}
              </button>
            </>
          ) : (
            <div
              className="d-flex align-items-center justify-content-center text-secondary"
              style={{ height: "100px", fontSize: "1rem" }}
            >
              Schedule not updated for this event
            </div>
          )}

          {/* Smaller Buttons on the Right Bottom */}
          <div className="position-absolute bottom-0 end-0 mb-2 me-2 d-flex flex-column align-items-end">
            <div className="d-flex flex-row">
              {imageUrl && (
                <>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "50px",
                      zIndex: 2,
                      padding: "6px",
                      borderRadius: "80%",
                      border: "1px solid #212121",
                      background: "#FFF",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {" "}
                    <button
                      onClick={handleDownloadClick}
                      className="cursor-pointer border-none p-0"
                    >
                      <IoDownloadOutline />
                    </button>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "10px",
                      zIndex: 2,
                      padding: "6px",
                      borderRadius: "80%",
                      border: "1px solid #212121",
                      background: "#FFF",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <button
                      onClick={handleViewClick}
                      className="cursor-pointer border-none p-0" // Removed additional padding
                    >
                      <IoEyeOutline />
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
